import { useEffect, useRef } from "react";

/** Mimics `useEffect`, but skips the effect on the initial mount.
 *
 * It's useful when you want the effect to run only on updates, not the first render.
 */
export const useDidUpdateEffect = (
  callback: () => void | VoidFunction,
  dependencies: unknown[] = [],
): void => {
  const didMount = useRef(false);

  useEffect(() => {
    if (didMount.current) {
      return callback();
    }

    didMount.current = true;

    return undefined;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, dependencies);
};
